import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DataService } from '../services/data/data.service';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    date = new Date();

    private stateUrl: string;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private jwtHelperSrv: JwtHelperService,
        private dataService: DataService
    ) { }

    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    //     const currentUser = this.authenticationService.currentUserValue;
    //     if (currentUser) {
    //         // logged in so return true
    //         return true;
    //     } else {
    //         this.dataService.isConnect.next(false);
    //     }


    //     // not logged in so redirect to login page with the return url
    //     // const date = new Date(localStorage.getItem('bizz-ffv-token-exp'));
    //     // const dateTokenExp = localStorage.getItem('bizz-ffv-token-exp');

    //     // if (localStorage.getItem('bizz-ffv-rf-token')) {
    //     //     if (dateTokenExp && this.date > date) {
    //     //         this.authenticationService.refreshToken().subscribe(() => {
    //     //         });
    //     //     }
    //     // }
    //     this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    //     return false;
    // }


    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        this.stateUrl = state.url;
        // No token
        if (!this.jwtHelperSrv.tokenGetter()) {
            this.logout();
            return false;
        }


        // token valid and up to date
        if (this.authenticationService.isAuth()) {

            return true;
        }



        // Token exists but outdated
        return this.refreshToken();
    }

    private refreshToken(): Observable<boolean> {
        // this.uiSrv.routeLoadingStateChanged.next(true);

        return this.authenticationService.refreshToken().pipe(
            map(() => {
                // this.uiSrv.routeLoadingStateChanged.next(false);
                return true;
            }),
            catchError(error => {
                // this.uiSrv.routeLoadingStateChanged.next(false);
                this.logout();
                return of(error);
            })
        );
    }

    private logout(): void {
        this.authenticationService.logout(this.stateUrl);
    }

}
